import uniq from 'lodash-es/uniq';
import {
    SellerSearchLoadApiSuccessAction,
    SELLER_SEARCH_LOAD_API_SUCCESS,
} from 'mk2/apps/bazaar/containers/SellerSearch/SellerSearch.actions';
import { initialState } from 'mk2/apps/bazaar/containers/SellerSearch/SellerSearch.constants';
import { errorMessageFiltered } from 'mk2/reducers/errorMessage';
import { loadingStateFiltered, LoadingState } from 'mk2/reducers/loadingState';
import { combineReducers, Reducer } from 'redux';

export interface State {
    ids: number[];
    loadingState: LoadingState;
    errorMessage: string;
    total: number;
}

type SellerSearchApiSuccessAction = SellerSearchLoadApiSuccessAction;

const ids: Reducer<number[]> = (state: number[] = [], action: SellerSearchApiSuccessAction) => {
    switch (action.type) {
        case SELLER_SEARCH_LOAD_API_SUCCESS:
            return action.start === 0 ? action.response.result.sellers : uniq([ ...state, ...action.response.result.sellers ]);
        default:
            return state;
    }
};

const total: Reducer<number> = (state: number = initialState.total, action: SellerSearchApiSuccessAction) => {
    switch (action.type) {
        case SELLER_SEARCH_LOAD_API_SUCCESS:
            return action.total;
        default:
            return state;
    }
};

const sellerSearchReducer: Reducer<State> = combineReducers({
    loadingState: loadingStateFiltered('SELLER_SEARCH_LOAD_API'),
    errorMessage: errorMessageFiltered('SELLER_SEARCH_LOAD_API'),
    ids,
    total,
});

export default sellerSearchReducer;
